import { NameDto } from './NameDto'

export interface TradingAccountRebateDetailedDto {
  tradingAccount: NameDto<string>
  client: NameDto<string> | null
  tradingAccountType: NameDto<number> | null
  country: NameDto<string> | null
  rebateGroup: NameDto<string> | null
  rebateApprovalType: NameDto<number> | null
  tradingAccountSignedUpDate: string
  totalVolumeFxm: number
  totalVolumeOther: number
  totalCommission: number
  rebateAmountInPercentage: number | null
  rebatePeriod: NameDto<number> | null
}

export const hasGroupRebateSettings = (client: TradingAccountRebateDetailedDto): boolean => {
  return !!client.rebateGroup
}

export const hasIndividualRebateSettings = (client: TradingAccountRebateDetailedDto): boolean => {
  return !client.rebateGroup && client.rebateAmountInPercentage !== null
}

export const hasRebateSettings = (client: TradingAccountRebateDetailedDto): boolean => {
  return hasGroupRebateSettings(client) || hasIndividualRebateSettings(client)
}
